export default function FullEmptyIndicator({ value }) {
	return <div className="full-empty-indicator-wrapper" style={{ paddingTop: '3px', marginBottom: '-3px' }}>
		<span className={'full-empty-indicator full-empty-indicator-' + (value ? 'full' : 'empty')} />
	</div>;
}